import { render, staticRenderFns } from "./noOpen.vue?vue&type=template&id=2dc1a890&scoped=true"
import script from "./noOpen.vue?vue&type=script&lang=js"
export * from "./noOpen.vue?vue&type=script&lang=js"
import style0 from "./noOpen.vue?vue&type=style&index=0&id=2dc1a890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc1a890",
  null
  
)

export default component.exports